import { useGetAccountsQuery } from "@/modules/account/services";
import type { ICardTransferTemplateForm } from "@/modules/template/common/types";
import { cardTransferTemplateValidationSchema } from "@/modules/template/validations";
import { INITIAL_PAGE_SIZE } from "@/shared/common/constants";
import type { IOperationPageProps } from "@/shared/common/types";
import { PageHeader } from "@/shared/components";
import { useTranslationExists } from "@/shared/hooks";
import { FormContainer } from "@ab.uitools/ui-library/components/FormContainer";
import { useState } from "react";

import { CardTransferTemplateForm } from "./CardTransferTemplateForm";

export const CardTransferTemplate = ({ isEdit }: IOperationPageProps) => {
  const { t } = useTranslationExists();
  const [isCardNumberInvalid, setIsCardNumberInvalid] = useState<boolean>(false);
  const { data: accountsList = [] } = useGetAccountsQuery({
    pageSize: INITIAL_PAGE_SIZE,
  }, {
    refetchOnMountOrArgChange: true,
  });

  const initialValues: ICardTransferTemplateForm = {
    creditCardNumber: "",
    debitAccount: "",
    amount: "",
    name: "",
    purpose: "",
    commissionAccount: "",
  };

  return (
    <FormContainer
      className="full-width page-container form-layout"
      formId="form-container"
      mode="onBlur"
      reValidateMode="onBlur"
      initialValues={initialValues}
      validationScheme={cardTransferTemplateValidationSchema({ t, isCardNumberInvalid })}
    >
      <PageHeader/>
      <CardTransferTemplateForm
        isEdit={isEdit}
        accountsList={accountsList}
        setIsCardNumberInvalid={setIsCardNumberInvalid}
      />
    </FormContainer>
  );
};
